// extracted by mini-css-extract-plugin
export default {"root":"RegisterPanel-root--WVY89"};